import React, {useContext} from "react";
import Button from 'react-bootstrap/Button';

import Context from "../context";
import { theme } from '../../../../theme';
import SalesInvoicesList from "./salesInvoicesList";
import ModalTemplate from "../../../../components/modal/modalTemplate";

const SalesInvoices = () => {
    const context = useContext(Context);

    return (
        <ModalTemplate
            show={context.state.is_show_sales_invoices}
            closeFun = {() => context.dispatch({
                type: 'IS_SHOW_SALES_INVOICES',
                is_show_sales_invoices: false
            })}
            size = {"lg"}
            centered = {true}
            title = {"Sales Invoices"}
            body = {<SalesInvoicesList />}
            footer = {
                <Button
                    variant={theme.close_btn}
                    onClick={() => context.dispatch({
                        type: 'IS_SHOW_SALES_INVOICES',
                        is_show_sales_invoices: false
                    })}
                    size="sm"
                >
                    CLOSE
                </Button>
            }
        />
    );
}

export default SalesInvoices;